import React, { useState, useEffect } from "react";

import { FaQuestionCircle } from "react-icons/fa";
import { Container, Frame, Polygon } from "./styles";

const Info = (props) => {
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (active) {
      setTimeout(() => {
        setActive(false);
      }, 5000);
    }
  }, [active]);

  return (
    <Container
      onClick={() => setActive(!active)}
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
      inline={props.inline}
    >
      <FaQuestionCircle size={14} color="#000" />
      {active && (
        <Frame onClick={() => setActive(false)}>
          <span>{props.value}</span>
        </Frame>
      )}
    </Container>
  );
};

export default Info;
